export default "__VITE_ASSET__3eb1456e__"